import {
  DatiTitolare,
  RichiestaModuloDTO,
  useGetFrontRichiesteIdGestore,
  useGetFrontRichiesteIdModuliDeleghe,
  useGetFrontRichiesteIdProcuratore,
} from '@framework/api-client';
import {
  DelegationLogic,
  IDelegationData,
} from '@framework/frontoffice-submission';
import { useMemo } from 'react';

function getApplicantName(applicant: DatiTitolare) {
  if (!applicant.nome && !applicant.cognome)
    return applicant.codiceFiscale ?? '';
  return `${applicant.nome} ${applicant.cognome}`;
}

export function useDelegationData(params: {
  submissionId: string | null | undefined;
  applicant: DatiTitolare[] | null | undefined;
  modules: RichiestaModuloDTO[];
}) {
  const { submissionId, modules, applicant } = params;
  // Deleghe
  const {
    data,
    isLoading: delegationLoading,
    error: delegationError,
  } = useGetFrontRichiesteIdModuliDeleghe(submissionId ?? '<unknown>');
  // gestore
  const {
    data: manager,
    isLoading: managerLoading,
    error: managerError,
  } = useGetFrontRichiesteIdGestore(submissionId ?? '<unknown>');
  // procuratore
  const {
    data: attorney,
    isLoading: attorneyLoading,
    error: attorneyError,
  } = useGetFrontRichiesteIdProcuratore(submissionId ?? '<unknown>');

  const delegationData = useMemo<IDelegationData>(() => {
    const moduleDelegation = DelegationLogic.getModuleDelegations({
      modules,
      data: data ?? [],
    });

    return {
      // Titolare
      applicant:
        applicant?.map(applicant => ({
          fiscalCode: applicant.codiceFiscale ?? '',
          name: getApplicantName(applicant),
          // Solo il titolare principale può inoltrare la pratica
          canSubmit: applicant.flTitolarePrincipale ?? false,
          isMain: applicant.flTitolarePrincipale ?? false,
        })) ?? [],
      // Gestore
      manager: manager?.codiceFiscale
        ? {
            fiscalCode: manager?.codiceFiscale ?? '',
            name: DelegationLogic.getNameWithDefault(manager),
          }
        : null,
      // Procuratore
      attorney: attorney?.datiProcura
        ? {
            fiscalCode: attorney?.datiProcura?.codiceFiscale ?? '',
            name: DelegationLogic.getNameWithDefault(attorney.datiProcura),
            canSubmit: attorney.datiProcura?.permetteInoltro ?? false,
            uploadedFileId: attorney.datiProcura?.fileProcura,
          }
        : null,
      // Deleghe visibilità/firma/visibilità
      moduleDelegation: moduleDelegation,
    };
  }, [modules, data, manager, attorney, applicant]);

  return {
    delegationData,
    isLoading: delegationLoading || managerLoading || attorneyLoading,
    error: delegationError ?? managerError ?? attorneyError,
  };
}
